import {useArtworkCreated} from '../artwork-created/useArtworkCreated.js'
import {ArtworkProgress} from '../artwork-created/ArtworkProgress.jsx'

// Exactly the same authorized read projection as the row, headline and new tool.
// A failed read never creates work or substitutes an account-name match.
export default function ChampionshipArtworkStatus({record,onOpenDossier}) {
  const read = useArtworkCreated(record?.sourceType || record?.isIndyGroup ? null : record?.id)
  const rows=read.rows?.length?read.rows:read.row?[read.row]:[]
  return <div aria-label="Linked championship artwork">
    {rows.length ? rows.map(row=><ArtworkProgress key={row.jobId} row={row} />) : <p role="status">{read.state === 'error' || read.state === 'conflict'
      ? 'Artwork read unavailable or conflicting; saved artwork may exist. Refresh the read rather than recreate it.'
      : read.state !== 'ready' ? 'Reading linked artwork…' : 'No linked saved original was observed in this authorized read. This is not a request to create another job.'}</p>}
    <button type="button" className="btn" onClick={read.refresh}>Refresh artwork status</button>
    {onOpenDossier && <button type="button" className="btn" onClick={()=>onOpenDossier(record)}>Review artwork in dossier</button>}
  </div>
}
